import React, { Component } from 'react';

//componentes
import ReportePago from './reportePago'

class Index extends Component {

    render(){
        return(
            <div>
                <ReportePago />
            </div>
        );
    }

}
export default Index;